import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './use-auth';
import Intercom from '@intercom/messenger-js-sdk';
import { usePostHog } from 'posthog-js/react';
import { IntercomProvider } from 'react-use-intercom';
import { useIntercomEnabled } from '../utils/feature-flags';

const INTERCOM_APP_ID = 'r9m7ot8l';

type Props = {
  children: ReactNode;
};

export function ProtectedRoute({ children }: Props) {
  const { isLoggedIn, loading, identity } = useAuth();
  const posthog = usePostHog();
  const intercomEnabled = useIntercomEnabled();

  if (loading) {
    return null;
  } else if (!isLoggedIn) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }
  if (identity) {
    posthog.identify(
      identity.email,
      { email: identity.email, name: identity.name } // optional: set additional person properties
    );
  }
  if (identity && intercomEnabled) {
    Intercom({
      app_id: INTERCOM_APP_ID,
      user_id: identity.email,
      name: identity.name,
      email: identity.email
    });
  }
  // The provider stays mounted even with Intercom off so `useIntercom` consumers keep their
  // context; `shouldInitialize` is what actually keeps the widget script off the page.
  return (
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      autoBoot={intercomEnabled}
      shouldInitialize={intercomEnabled}>
      {children}
    </IntercomProvider>
  );
}
